import { Injectable } from "@angular/core";
import { Query } from '@datorama/akita';
import { UserState, UserStore } from './user.store';
import { CookieService } from 'ngx-cookie';
import { Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { Auth } from 'aws-amplify';
import { switchMap, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserQuery extends Query<UserState>{
    readonly tokenName = 'oneCG_token';
      SamlUserKey:string='SamlUser';
    UserName="abc";
    Password="test";
    message=''
    MemberShipAPIRes:any
    constructor(protected store: UserStore,
        private cookie: CookieService,
        private router: Router) {
        super(store);
    }

    user() {
        return this.select(user => {
            return user.data
        });
    }

    getToken() {
        return this.cookie.get(this.tokenName);
    }
    //new added on 12th may
    getTokenForAPI(): string {
        return this.getToken();
      }
      
    setToken(token) {
        return this.cookie.put(this.tokenName, token);
       
    }

    getUserName() {
        return this.UserName
       // return this.cookie.get(this.UserName);
    }

    setUserName(username) {
        this.UserName=username;
       // return this.cookie.put(this.UserName, username);
    }
    getPassword() {
        return this.Password
        //return this.cookie.get(this.Password);
    }

    setPassword(password) {
        this.Password=password
      //  return this.cookie.put(this.Password, password);
    }
    alreadyLogged() {
        return this.select(user => {
            return user.data;
        });
    }

    currentPlan() {
        return this.select(user => {
            return user.plan;
        });
    }
    /*i have added this function to set the valueee of roleList API and i am calling this
   function in home page and get the result of it to use in other component to reduce the call of API*/
 setRole(role: any) {
  this.store.update(state => ({
    ...state,
    role: role
  }));
}
getRole(): Observable<any> {
  return this.select(state => state.role);
}
    setCurrentPlan(planId) {
        this.store.update(state => {
            return {
                ...state,
                plan: planId
            }
        });
    }

    currentSession() {
        const ob = new Observable(r => {
            r.next();
        });
        return ob.pipe(
            take(1),
            switchMap(res => {
                return Auth.currentAuthenticatedUser();
            }),
            switchMap((res: any) => {
                if (res) {
                    return of(res)
                } else {
                    this.logout();
                    throwError(false)
                }
            })
        );
    }

    validateUser() {
        const token = this.getToken();
    }

    setUser(data) {
        this.store.update(state => {
            return {
                isLoggedIn: true,
                data: data
            }
        });
    }

    setUserImg(img) {
        this.store.update(state => {
            return {
                ...state,
                data: {
                    ...state.data,
                    profileImg: img
                }
            }
        });
    }

    removeUser() {
        this.cookie.remove(this.tokenName);

        this.store.update(state => {
            return {
                isLoggedIn: false,
                data: null
            }
        })
    }

    logout(broadcast: boolean = true) {
        // Clear app storage
        localStorage.clear();
        sessionStorage.clear();

        // Expire all cookies for current domain/path
        const cookies = document.cookie.split(';');
        const hostname = window.location.hostname;
        for (const cookie of cookies) {
            const eqPos = cookie.indexOf('=');
            const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
            if (!name) {
                continue;
            }
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${hostname}`;
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${hostname}`;
        }

        this.removeUser();
        if (broadcast) {
            const payload = `${Date.now()}`;
            localStorage.setItem('onecg_logout', payload);
            if (typeof BroadcastChannel !== 'undefined') {
                const channel = new BroadcastChannel('onecg_logout');
                channel.postMessage(payload);
                channel.close();
            }
        }
        this.router.navigateByUrl('/');
    }
      getSamlUser(){
        return this.cookie.get(this.SamlUserKey);
    }
    setSamlUser(SamlUser){
       return this.cookie.put(this.SamlUserKey, SamlUser);
    }
    setMemmbershipAPIRes(MemberShipAPIRes){
this.MemberShipAPIRes=MemberShipAPIRes
    }
    getMembershipRes(){
        return this.MemberShipAPIRes;
    }
     setMessage(msg: string) {
    this.message = msg;
  }

  getMessage() {
    return this.message;
  }

}
